import { useEffect } from 'react';
import { AppContainer } from '@/components/AppContainer/AppContainer';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './DetailedGiveawayPage.module.scss';
import { BackButton } from '@/components/BackButton';
import { fetchGiveaways } from '@/api';
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import DetailedGiveawayBanner from './DetailedGiveawayBanner';
import DetailedGiveawayInfo from './DetailedGiveawayInfo';
import DetailedGiveawayPrizes from './DetailedGiveawayPrizes';
import { useProfileMenuStore } from '@/store/useProfileMenuStore';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import GiveawayModal from './GiveawayModal';
import { useModalStore } from '@/store/ModalStore';
import { purchaseCoupon } from '@/api/modules/giveaway';
import useGiveawaysStore from '@/store/ShortGiveawaysStore';
import useBalanceStore from '@/store/BalanceStore';
import { useNotificationStore } from '@/store/NotificationStore';

const DetailedGiveawayPage = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate('/');
  };
  const { id } = useParams();
  const setGiveaways = useGiveawaysStore((state) => state.setGiveaways);
  const setBalance = useBalanceStore((state) => state.setBalance);
  useEffect(() => {
    useProfileMenuStore.getState().setVisibility(false);
    useNavMenuStore.getState().setVisibility(false);
    return () => {
      useProfileMenuStore.getState().setVisibility(true);
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  const { data: giveawayData, isLoading } = useQuery({
    queryKey: ['giveaway', Number(id)],
    queryFn: () => fetchGiveaways(Number(id)),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
  });

  const open = useModalStore((state) => state.open);
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );

  const handlePurchase = async (
    giveawayId: number,
    amount: number,
    couponType: string,
  ) => {
    try {
      const response = await purchaseCoupon(giveawayId, amount, couponType);
      await queryClient.invalidateQueries({
        queryKey: ['giveaway', Number(id)],
      });
      const updated = await queryClient.fetchQuery({
        queryKey: ['giveaways'],
        queryFn: () => fetchGiveaways(),
      });
      setGiveaways(updated);
      setBalance(response);
      setNotification({
        message: 'Билеты успешно куплены!',
        type: 'Success',
      });
    } catch (error) {
      console.log(error);
    }
    console.log('clicked');
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }
  console.log(giveawayData);
  return (
    <AppContainer>
      <div className={styles.content}>
        <BackButton visible={true} onClick={handleBackClick} />
        <div className={styles.containerDiv}>
          {giveawayData && <DetailedGiveawayBanner giveaway={giveawayData} />}
          {giveawayData && <DetailedGiveawayInfo giveaway={giveawayData} />}
          {giveawayData && giveawayData.status === 'active' && open && (
            <GiveawayModal
              couponType={giveawayData.config.entry_fee_type}
              couponPrice={giveawayData.config.entry_fee_price}
              purchased={giveawayData.user_purchased_coupons.quantity}
              giveawayId={giveawayData.id}
              onPurchase={handlePurchase}
            />
          )}
          {giveawayData && <DetailedGiveawayPrizes giveaway={giveawayData} />}
        </div>
      </div>
    </AppContainer>
  );
};

export default DetailedGiveawayPage;
